import { NAV_SECTION_HREFS, type NavSectionHref } from '~/constants/sections'

function getScrollOffset() {
  const header = document.querySelector('.site-header')
  return header?.getBoundingClientRect().height ?? 68
}

export function useActiveSection() {
  const activeSection = useState<NavSectionHref>('active-nav-section', () => NAV_SECTION_HREFS[0])

  function updateActiveSection() {
    const offset = getScrollOffset()
    const trigger = offset + (window.innerHeight - offset) * 0.35

    const atPageBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2
    if (atPageBottom) {
      activeSection.value = NAV_SECTION_HREFS[NAV_SECTION_HREFS.length - 1]
      return
    }

    let current: NavSectionHref = NAV_SECTION_HREFS[0]
    for (const href of NAV_SECTION_HREFS) {
      const section = document.querySelector<HTMLElement>(href)
      if (!section) continue

      if (section.getBoundingClientRect().top <= trigger) {
        current = href
      }
    }

    activeSection.value = current
  }

  let onScroll: (() => void) | null = null

  onMounted(() => {
    const hash = window.location.hash
    if (NAV_SECTION_HREFS.includes(hash as NavSectionHref)) {
      activeSection.value = hash as NavSectionHref
    }

    let ticking = false
    onScroll = () => {
      if (ticking) return
      ticking = true
      requestAnimationFrame(() => {
        updateActiveSection()
        ticking = false
      })
    }

    updateActiveSection()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll, { passive: true })
  })

  onUnmounted(() => {
    if (!onScroll) return
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onScroll)
  })

  function setActiveSection(href: string) {
    if (NAV_SECTION_HREFS.includes(href as NavSectionHref)) {
      activeSection.value = href as NavSectionHref
    }
  }

  return { activeSection, setActiveSection, updateActiveSection }
}